export type Configs = {
  REACT_APP_TAP_PAY_ID: string;
  REACT_APP_TAP_PAY_API_KEY: string;
  REACT_APP_TAP_PAY_API: string;
  REACT_APP_TAP_PAY_MODE: string;
  REACT_APP_ENV: string;
  REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY: string;
};

const address = process.env.NODE_ENV === "production" ? "./prod" : "./dev";

// eslint-disable-next-line
const configs = require(`${address}`).default;

export default configs;
